// One chip, one vocabulary. The dashboard, the league index and the league
// page each carried their own copy of the status colour table, and all three
// printed the database's word for the state.
import React from 'react';
import { statusStyle } from '../../utils/leagueStatus';

export const StatusChip: React.FC<{ status?: string | null; className?: string }> = ({
  status,
  className = '',
}) => {
  const { label, className: tone } = statusStyle(status);
  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 text-[0.65rem] font-semibold uppercase tracking-wider ${tone} ${className}`}
    >
      {label}
    </span>
  );
};

export default StatusChip;
